import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { db } from '../..'
import { ref, onValue, off } from 'firebase/database'

const ReportViewModal = ({ isOpen, onClose, gameId, historyKey, historyItem }) => {
    const [reports, setReports] = useState([])
    const [loading, setLoading] = useState(false)

    const customStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            borderRadius: '10px',
            padding: '0',
            overflow: 'hidden'
        },
    }

    useEffect(() => {
        if (isOpen && gameId && historyKey) {
            setLoading(true)
            const reportsRef = ref(db, `gameLogs/${gameId}/reports/${historyKey}`)
            
            onValue(reportsRef, (snapshot) => {
                if (snapshot.exists()) {
                    const reportsData = snapshot.val()
                    const reportsArray = Object.keys(reportsData).map(key => ({
                        id: key,
                        ...reportsData[key]
                    })).sort((a, b) => b.timestamp - a.timestamp)
                    
                    setReports(reportsArray)
                } else {
                    setReports([])
                }
                setLoading(false)
            })

            return () => {
                off(reportsRef)
            }
        }
    }, [isOpen, gameId, historyKey])

    const handleClose = () => {
        setReports([])
        onClose()
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleClose}
            style={customStyles}
            contentLabel="通報確認"
        >
            <div className="bg-white h-full flex flex-col">
                {/* ヘッダー */}
                <div className="bg-orange-50 px-4 py-3 border-b flex justify-between items-center flex-shrink-0">
                    <h2 className="text-lg font-semibold text-orange-700">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        通報一覧 ({reports.length}件)
                    </h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>

                {/* 通報対象の情報 */}
                <div className="px-4 py-3 bg-gray-50 border-b flex-shrink-0">
                    <div className="text-sm text-gray-600 mb-1">通報対象</div>
                    <div className="font-medium text-gray-800">
                        {historyItem?.team?.name} - {historyItem?.missionTitle}
                    </div>
                    <div className="text-xs text-gray-500">
                        {historyItem?.time && new Date(historyItem.time).toLocaleString()}
                    </div>
                </div>

                {/* 通報リスト */}
                <div className="flex-1 overflow-y-auto">
                    {loading ? (
                        <div className="text-center py-8">
                            <div className="text-gray-500">読み込み中...</div>
                        </div>
                    ) : reports.length === 0 ? (
                        <div className="text-center py-8">
                            <div className="text-gray-500">通報はありません</div>
                        </div>
                    ) : (
                        <div className="divide-y divide-gray-200">
                            {reports.map((report, index) => (
                                <div key={report.id} className="p-4">
                                    <div className="flex justify-between items-start mb-2">
                                        <div className="text-sm font-medium text-gray-800">
                                            通報 #{index + 1}
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            {new Date(report.timestamp).toLocaleString()}
                                        </div>
                                    </div>
                                    <div className="text-sm text-gray-600 whitespace-pre-wrap leading-relaxed">
                                        {report.content}
                                    </div>
                                    <div className="text-xs text-gray-400 mt-2">
                                        通報者ID: {report.reportedBy?.substring(0, 8)}...
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* フッター */}
                <div className="px-4 py-3 bg-gray-50 border-t flex-shrink-0">
                    <button
                        onClick={handleClose}
                        className="w-full px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                    >
                        閉じる
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default ReportViewModal